import { useMemo } from 'react';

import { useDeviceConfigurationCache } from './useDeviceConfigurationCache';

export function useEboxConfiguration() {
  const { configuration } = useDeviceConfigurationCache();

  return useMemo(() => {
    if (!configuration?.ebox) {
      return undefined;
    }

    return configuration.ebox;
  }, [configuration]);
}

export function useEboxAppConfiguration() {
  const configuration = useEboxConfiguration();

  return useMemo(() => {
    if (!configuration) {
      return undefined;
    }

    return configuration.app;
  }, [configuration]);
}
